import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { formatDate } from '../components/crm/crmConstants';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [summaries, setSummaries] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    company_name: '', contact_name: '', phone: '', email: '',
    address: '', tax_office: '', tax_number: '', notes: '',
    payment_terms: 30, currency: 'USD'
  });

  const fetchCustomers = async () => {
    const [res, sum] = await Promise.all([
      api.get('/api/customers/'),
      api.get('/api/crm/customers/summaries'),
    ]);
    setCustomers(res.data);
    setSummaries(Object.fromEntries(sum.data.map(s => [s.customer_id, s])));
  };

  useEffect(() => { fetchCustomers(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/api/customers/${editing.id}`, form);
      } else {
        await api.post('/api/customers/', form);
      }
      setShowForm(false);
      setEditing(null);
      setForm({ company_name: '', contact_name: '', phone: '', email: '', address: '', tax_office: '', tax_number: '', notes: '', payment_terms: 30, currency: 'USD' });
      fetchCustomers();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const handleEdit = (customer) => {
    setEditing(customer);
    setForm(customer);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Müşteriyi silmek istediğinize emin misiniz?')) return;
    await api.delete(`/api/customers/${id}`);
    fetchCustomers();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Müşteriler</h2>
        <button
          onClick={() => { setShowForm(true); setEditing(null); }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium"
        >
          + Yeni Müşteri
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg max-h-screen overflow-y-auto">
            <h3 className="text-lg font-bold mb-4">{editing ? 'Müşteri Düzenle' : 'Yeni Müşteri'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Firma Adı *</label>
                  <input required value={form.company_name} onChange={e => setForm({...form, company_name: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Yetkili Kişi</label>
                  <input value={form.contact_name || ''} onChange={e => setForm({...form, contact_name: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                  <input value={form.phone || ''} onChange={e => setForm({...form, phone: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Para Birimi</label>
                  <select value={form.currency} onChange={e => setForm({...form, currency: e.target.value})} className="w-full border rounded px-3 py-2">
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="TRY">TRY</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Vergi Dairesi</label>
                  <input value={form.tax_office || ''} onChange={e => setForm({...form, tax_office: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Vergi No</label>
                  <input value={form.tax_number || ''} onChange={e => setForm({...form, tax_number: e.target.value})} className="w-full border rounded px-3 py-2" />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Adres</label>
                  <textarea value={form.address || ''} onChange={e => setForm({...form, address: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Notlar</label>
                  <textarea value={form.notes || ''} onChange={e => setForm({...form, notes: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Firma</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Yetkili</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Telefon</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Email</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Para Birimi</th>
              <th className="text-center px-6 py-3 text-sm font-medium text-gray-500">Açık Fırsat</th>
              <th className="text-center px-6 py-3 text-sm font-medium text-gray-500">Görev</th>
              <th className="text-left px-6 py-3 text-sm font-medium text-gray-500">Son Temas</th>
              <th className="text-right px-6 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {customers.map(c => {
              const s = summaries[c.id];
              return (
              <tr key={c.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 font-medium">
                  <button onClick={() => navigate(`/customers/${c.id}`)} className="text-gray-800 hover:text-blue-600 hover:underline text-left">{c.company_name}</button>
                </td>
                <td className="px-6 py-4 text-gray-600">{c.contact_name || '-'}</td>
                <td className="px-6 py-4 text-gray-600">{c.phone || '-'}</td>
                <td className="px-6 py-4 text-gray-600">{c.email || '-'}</td>
                <td className="px-6 py-4 text-gray-600">{c.currency}</td>
                <td className="px-6 py-4 text-center text-gray-600">{s?.open_opportunities || '-'}</td>
                <td className="px-6 py-4 text-center">
                  {s?.open_tasks ? (
                    <span className={`text-xs px-2 py-1 rounded font-medium ${s.overdue_tasks ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'}`}>
                      {s.open_tasks}{s.overdue_tasks ? ` (${s.overdue_tasks} gecikmiş)` : ''}
                    </span>
                  ) : <span className="text-gray-400">-</span>}
                </td>
                <td className="px-6 py-4 text-gray-600 text-sm">{s?.last_activity_at ? formatDate(s.last_activity_at) : '-'}</td>
                <td className="px-6 py-4 text-right whitespace-nowrap">
                  <button onClick={() => navigate(`/customers/${c.id}`)} className="text-green-600 hover:text-green-800 font-medium text-sm mr-3">Detay</button>
                  <button onClick={() => navigate(`/customers/${c.id}/prices`)} className="text-purple-600 hover:text-purple-800 font-medium text-sm mr-3">Özel Fiyatlar</button>
                  <button onClick={() => handleEdit(c)} className="text-blue-600 hover:text-blue-800 font-medium text-sm mr-3">Düzenle</button>
                  <button onClick={() => handleDelete(c.id)} className="text-red-500 hover:text-red-700 font-medium text-sm">Sil</button>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
        {customers.length === 0 && (
          <div className="text-center py-12 text-gray-400">Henüz müşteri eklenmemiş</div>
        )}
      </div>
    </div>
  );
}
